<template lang="pug">
  v-container.grey.lighten-5.fill-height(fluid)
    Drawer( v-model="drawer" )
    Header(
      :drawerState = 'drawer'
      @toggleDrawer="toggleDrawer"
    )
    v-content.align-self-start
        slot
</template>

<script>
import Drawer from './Default/Drawer.vue'
import Header from './Default/Header.vue'

export default {
  components: {
    Drawer,
    Header
  },
  props: {
    source: String
  },
  data() {
    return {
      drawer: true
    }
  },
  methods: {
    toggleDrawer(val) {
      this.drawer = val
    }
  }
}
</script>
